import type { AppState } from '../AppState';
import { INITIAL_STATE } from '../AppState';

export type LegacyAppState = {
  appVer: string;
  trackingId: string;
  sessionCount: number;
  level: number;
  coins: number;
};

export function convertLegacyAppState(legacyState: LegacyAppState): AppState {
  return {
    ...INITIAL_STATE,
    trackingId: legacyState.trackingId,
    sessionCount: legacyState.sessionCount,
    levelIndex: legacyState.level,
    coins: legacyState.coins,
  };
}
